module.exports = __webpack_public_path__ + "static/media/hero.e27b4354.svg";